module.exports = __webpack_public_path__ + "portal-static/img/test.61d0e6b2.png";